module.exports = __webpack_public_path__ + "static/media/vintage15.fd7c6105.png";